import {
  Component,
  DestroyRef,
  computed,
  inject,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ToastAction, ToastType } from './toast.config';
import { NttFeaturedIcon } from '../composite/featured-icon';
import { FeaturedIconColor } from '../composite/featured-icon/featured-icon.types';
import { NttLinkButton } from '../button';

@Component({
  selector: 'ntt-alert',
  imports: [NttFeaturedIcon, NgTemplateOutlet, NttLinkButton],
  templateUrl: './alert.html',
  styleUrl: './alert.scss',
})
export class NttAlert {
  type = input<ToastType>('default');
  message = input<string>();
  dismissible = input(true);
  actionsTemplate = input<TemplateRef<unknown>>();
  action = input<ToastAction>();
  dismiss = output();
  enter = output();
  leave = output();

  private _alive = true;

  constructor() {
    inject(DestroyRef).onDestroy(() => {
      this._alive = false;
    });
  }

  protected emitEnter(): void {
    if (this._alive) this.enter.emit();
  }

  protected emitLeave(): void {
    if (this._alive) this.leave.emit();
  }

  protected handleActionDismiss() {
    if (!this._alive) return;
    this.dismiss.emit();
  }

  protected runAction(action: ToastAction) {
    if (!this._alive) return;
    action.handler();
    this.dismiss.emit();
  }

  protected readonly iconColor = computed<FeaturedIconColor>(() => {
    const typeMap: Record<ToastType, FeaturedIconColor> = {
      success: 'success',
      warning: 'warning',
      error: 'error',
      info: 'brand',
      default: 'gray',
    };
    return typeMap[this.type()];
  });

  protected readonly iconName = computed(() => {
    const typeMap: Record<ToastType, string> = {
      success: 'icon-check-circle',
      warning: 'icon-alert-circle',
      error: 'icon-alert-circle',
      info: 'icon-info-circle',
      default: 'icon-info-circle',
    };
    return typeMap[this.type()];
  });
}
